import React from 'react';

import loadingBlock from '../styles/LoadingBlock.module.css';

const LoadingBlock = ({ width, height }) => {
  return (
    <div className={loadingBlock.loadingPlaceholder} style={{ width: width, height: height }}></div>
  )
}

export default LoadingBlock;